module.exports = __webpack_public_path__ + "img/KE.97be210c.png";